import React from 'react';

import './autosuggest-basic.scss';

const AutosuggestBasic: React.FC = () => (
    <div className="react-autosuggest__container">
        <input
            aria-label="czego szukasz?"
            type="text"
            autoComplete="off"
            className="react-autosuggest__input"
            name="szukaj"
            placeholder="czego szukasz?"
        />
        <div className="react-autosuggest__suggestions-container">
            {''}
        </div>
    </div>
);

export default AutosuggestBasic;
